<template>
  <div>
    <OtherHeaderComponent />
    <div class="markets-container">
      <div class="header-image">
        <img src="@/public/images/markets-banner.png" alt="Markets Banner" />
      </div>

      <div class="markets-description">
        <ul class="market-list">
          <li>
            <div class="bullet"></div>
            <div>
              <p v-html="getTranslatedText('All numbers bets for a specific draw must be placed and confirmed before the draw cutoff, as well as before the first number is drawn for the wagered bet.')"></p>
            </div>
          </li>

          <li>
            <div class="bullet"></div>
            <div>
              <p v-html="getTranslatedText('If for any reason a bet is placed after the first number is drawn, the wagers will be voided and the full stake will be refunded.')"></p>
            </div>
          </li>

          <li>
            <div class="bullet"></div>
            <div>
              <p v-html="getTranslatedText('If a draw time is re-scheduled, the draw will be cancelled, and all affected wagers will be refunded. A new draw may be introduced with the re-scheduled time slot.')"></p>
            </div>
          </li>

          <li>
            <div class="bullet"></div>
            <div>
              <p v-html="getTranslatedText('Numbers draw shall be resulted in accordance with the first result obtained from the official Lucky Numbers website. If any mistakes and/or alternative submissions are published, the draw will be cancelled and all wagers will be refunded.')"></p>
            </div>
          </li>

          <li>
            <div class="bullet"></div>
            <div>
              <p v-html="getTranslatedText('All wagers that cannot be settled for any reason will be voided and refunded.')"></p>
            </div>
          </li>

          <li>
            <div class="bullet"></div>
            <div>
              <p v-html="getTranslatedText('All numbers betting markets are fixed odds bets, with one outcome, a win or a loss. No consolation prizes are offered for any draws and/or markets. All of the selected numbers drawn must match the wager entry in any order or must match the wagered market and must have resulted correctly for the bet to win.')"></p>
            </div>
          </li>

          <li>
            <div class="bullet"></div>
            <div>
              <p v-html="getTranslatedText('In standard bet markets, all the numbers selected for a wager must be drawn in order for it to be a winning bet. As an example, if four numbers are selected (Market 4 Numbers) and three of those four selected numbers are drawn, there is no win and no payout.')"></p>
            </div>
          </li>

          <li>
            <div class="bullet"></div>
            <div>
              <p v-html="getTranslatedText('For a successful wager, the player must select a market type, select the numbers or expected market outcome for a draw, choose the wager stake and make the bet before the Lucky Numbers draw has its first ball drawn or the cutoff countdown has expired, after which the results must be published correctly. Following the publishing of valid Lucky Numbers results, all wager payouts will be paid directly to the player account wallet.')"></p>
            </div>
          </li>

          <li>
            <div class="bullet"></div>
            <div>
              <p v-html="getTranslatedText('If any of the draws expire before the wager is finalized, these wagers may be moved to the next available draw by the player or they can be cancelled.')"></p>
            </div>
          </li>
        </ul>
      </div>

      <!-- Footer Navigation Buttons -->
      <div style="padding: 10px; margin-bottom: 50px;">
        <HomeFooterButton />
      </div>
    </div>
  </div>
</template>


<script>
import HomeFooterButton from "@/components/common/HomeFooterButton.vue";
import OtherHeaderComponent from "@/components/common/OtherHeaderComponent.vue";
import languageMixins from "@/mixins/language-mixins";
export default {
  name: "TermsAndConditions",
  mixins: [languageMixins],
  components: { HomeFooterButton, OtherHeaderComponent },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped>
.markets-container {
  max-width: 900px;
  margin: 0 auto;
  padding-left: 20px;
  padding-right: 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.header-image img {
  width: 100%;
  margin-bottom: 20px;
}

.markets-description {
  padding: 15px;
}

.market-list {
  list-style: none;
  padding: 0;

  li {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 20px;

    .bullet {
      width: 7px;
      height: 7px;
      border-radius: 50%;
      border: 1px solid #0000ff;
      margin-top: 6px;
      flex-shrink: 0;
    }

    strong {
      font-weight: bold;
      display: block;
      margin-bottom: 5px;
      color: #000;
    }

    p {
      margin: 0;
      font-size: 15px;
      line-height: 1.6;
      color: #333;
    }
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .markets-container {
    padding-bottom: 10px;
  }

  .header-image img {
    margin-bottom: 15px;
  }

  .market-list li p {
    font-size: 14px;
  }
}
</style>
